import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'
import { setSession } from 'utils/set-session'
import {
  getSubscriptionStatus,
} from 'services/subscriptions'
import InternalError from 'errors/internal-error'
import { useRouter } from 'next/router'
import {
  getPaymentCountryService,
} from 'services/payment'
import CheckoutLayout from 'checkout/checkout-layout'
import { prefetchSubscriptionPlans, useSubscriptionPlans } from 'querys/subscriptions'
import { prefetchPaymentConfig } from 'querys/payment'

function CheckoutSubscription() {
  const router = useRouter()
  const { data, isLoading, error } = useSubscriptionPlans()

  if (isLoading) return null

  if (error?.message === 'User Unauthorized') {
    router.push(`/login?next=${router.asPath}`)
    return null
  }
  if (error?.message === 'Internal Error') return <InternalError />

  const {
    month: plan,
  } = data
  const { name, price, discount } = plan
  const { price: monthPrice, original_price } = data.month
  const witdhDiscount = discount?.status === 'VALID'

  return (
    <CheckoutLayout
      title={name}
      subscriptionPlan={plan}
      url="https://leonidasesteban.com/comprar/anual"
      price={price}
      originalPrice={witdhDiscount ? original_price : {}}
      type="subscription"
      recurrency="month"
      courseImg="/icons/icon-96x96.png"
    />
  )
}

CheckoutSubscription.pageTheme = {
  background: 'var(--sky)',
}

export const getServerSideProps = async ({ req, res, query: { coupon_code } }) => {
  const queryClient = new QueryClient()
  const { token } = setSession(req, queryClient)
  if (token) {
    const data = await getSubscriptionStatus({ token, product: 'ALL', recurring: 'year' })
    if (data.is_active) {
      res.writeHead(302, { Location: '/aprender' })
      res.end()
    }
  }
  let country = ''
  const ip = req.headers['x-forwarded-for'] || req.connection.remoteAddress
  const { headers: { host } } = req
  if (host.includes('localhost') || host.includes(':3000')) {
    country = 'MX'
  } else {
    const data = await getPaymentCountryService({ ip })
    country = data.countryCode
  }
  await prefetchPaymentConfig(queryClient, country)
  await prefetchSubscriptionPlans({
    queryClient,
    countryCode: country,
    product: 'ALL',
    token,
    coupon_code,
  })

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  }
}

export default CheckoutSubscription
